<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered hide-header hide-footer>
      <div class="modal-header">
        <h4>{{msg}}</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">×</button>
      </div>
      <div class="text-center px-md-5 py-4">
        <p class="font-weight-bold">{{text}}</p>
      </div>
      <div class="form-inline justify-content-center mt-2">
        <b-button class="mr-2 btn-modal radius-btn" :variant="colorBtnCancel" @click="hide">{{btnCancel}}</b-button>
        <b-button class="ml-2 btn-modal radius-btn" :variant="colorBtnConfirm" @click="$emit('confirm')">{{btnConfirm}}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      required: false,
      type: String
    },
    text: {
      required: false,
      type: String
    },
    btnConfirm: {
      required: true,
      type: String
    },
    colorBtnConfirm: {
      required: false,
      type: String
    },
    btnCancel: {
      required: true,
      type: String
    },
    colorBtnCancel: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

::v-deep .modal-body {
  text-align: center;
  padding: 15px !important;
}
.btn-modal {
  width: 150px;
  font-weight: bold;
}
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
</style>